<template>
	<modal-box @close="close" :header="$t(`buttons.actions.${params.action}_healthreport`)" :subHeader="$t('headers.general.healthreports')" class="health-report-form">
		<div slot="buttons">
			<button @click="showView('report')" :class="btnClass('report')">{{ $t('buttons.general.report') }}</button>
			<button @click="showView('attachments')" :class="btnClass('attachments')">{{ $t('buttons.general.attachment') }}</button>
		</div>
		<spinner v-if="model.loading"/>
		<error-box v-else-if="model.error" :error="model.error"/>
		<form v-else @submit.prevent="validateAndSubmit">
			<div class="report" v-show="isView('report')">
				<input-text v-model="model.data.name" name="healthreport_name" :placeholder="$t('labels.general.name')" rules="required"/>
				<div class="form-row">
					<input-date v-model="model.data.date" name="healthreport_date" :placeholder="$t('labels.general.date')" rules="required"/>
					<input-time v-model="model.data.hour" name="healthreport_hour" :placeholder="$t('labels.general.hour')" rules="required" class="flex1"/>
				</div>
				<input-text v-model="model.data.responsible" name="healthreport_responsible" :placeholder="$t('labels.general.responsible')" rules="required"/>
				<input-textarea v-model="model.data.report" name="healthreport_report" :placeholder="$t('labels.general.report')" rules="required"/>
			</div>
			<div class="attachments" v-show="isView('attachments')">
				<file-upload :user_uid="user_uid" :watch_id="watch_id" :report_id="params.id" v-model="model.data.attachments" :active="isView('attachments')" @uploading="onFileUploading"/>
			</div>
			<error-box v-if="form.error" :error="form.error"/>
			<div class="form-group-actions">
				<label class="btn btn-icon-text btn-attach" for="file" v-if="isView('attachments')">
					<svgicon name="attachment" :fill="false"/>
					<spinner v-if="form.uploading" size="small"/>
					<span v-else>{{ $t('buttons.general.attach') }}</span>
				</label>
				<button-submit-icon-text :loading="form.loading || form.uploading" icon="save">{{ $t('buttons.general.save') }}</button-submit-icon-text>
			</div>
		</form>
	</modal-box>
</template>

<script>
import ApiObject from '@/classes/api/ApiObject'
import HealthReport from '@/classes/HealthReport'
import FileUpload from './HealthReportFileUpload'
export default {
	components: {
		FileUpload
	},
	props: [
		'user_uid',
		'watch_id',
		'params'
	],
	data () {
		return {
			name: 'watch healthreports form',
			model: new ApiObject(),
			form: {
				loading: false,
				uploading: false,
				error: ''
			},
			view: 'report'
		}
	},
	methods: {
		validateAndSubmit () {
			this.$validator.validateAll()
				.then(result => {
					if (result) this.submit()
				})
		},
		submit () {
			switch (this.params.action) {
				case 'add':
					this.addReport()
					break
				case 'edit':
					this.editReport()
					break
				default:
					this.$log.warn(this.name, 'action not set')()
			}
		},
		close (reload = false) {
			this.$emit('close', { reload })
		},
		getAttachmentMetadata (attachment) {
			const file_uid = attachment.file
			this.$api.files.getMetadata(this, this.user_uid, this.watch_id, file_uid)
				.then(response => {
					this.$log.info(this.name, 'files.getMetadata OK', response)()
					this.$set(attachment, 'metadata', response.body)
				}).catch(errors => {
					this.$log.error(this.name, 'files.getMetadata ERROR', errors)()
				})
		},
		getAllAttachmentMetadata () {
			if (this.model.data.attachments) {
				this.model.data.attachments.forEach(attachment => {
					if (!attachment.metadata) {
						this.getAttachmentMetadata(attachment)
					}
				})
			}
		},
		getReport () {
			this.model.loading = true
			this.$api.healthreports.get(this, this.user_uid, this.watch_id, this.params.id)
				.then(response => {
					this.$log.info(this.name, 'healthreports.get OK', response)()
					this.model.data = this.newHealthReport(response.body)
					this.getAllAttachmentMetadata()
				}).catch(error => {
					this.$log.error(this.name, 'healthreports.get ERROR', error)()
					this.model.error = error
				}).finally(() => {
					this.model.loading = false
				})
		},
		addReport () {
			this.form.loading = true
			const model = this.serializeModel()
			this.$api.healthreports.add(this, this.user_uid, this.watch_id, model)
				.then(response => {
					this.$log.info(this.name, 'healthreports.add OK', response)()
					this.close(true)
				}).catch(error => {
					this.$log.error(this.name, 'healthreports.add ERROR', error)()
					this.form.error = error
				}).finally(() => {
					this.form.loading = false
				})
		},
		editReport () {
			this.form.loading = true
			const model = this.serializeModel()
			this.$api.healthreports.edit(this, this.user_uid, this.watch_id, model)
				.then(response => {
					this.$log.info(this.name, 'healthreports.edit OK', response)()
					this.close(true)
				}).catch(error => {
					this.$log.error(this.name, 'healthreports.edit ERROR', error)()
					this.form.error = error
				}).finally(() => {
					this.form.loading = false
				})
		},
		newHealthReport (data) {
			const report = new HealthReport(data)
			if (data) {
				report.date = this.$moment(report.datetime).format('YYYY-MM-DD')
				report.hour = this.$moment(report.datetime).format('HH:mm')
			} else {
				report.date = this.$moment().format('YYYY-MM-DD'),
				report.hour = this.$moment().format('HH:mm')
			}
			delete report.datetime
			return report
		},
		serializeModel () {
			return {
				id: this.model.data.id,
				name: this.model.data.name,
				report: this.model.data.report,
				responsible: this.model.data.responsible,
				date_hour: this.$moment(`${this.model.data.date} ${this.model.data.hour}`).format(),
				attachments: this.model.data.attachments
			}
		},
		showView (view) {
			this.view = view
		},
		isView (view) {
			return this.view === view
		},
		btnClass (view) {
			return { active: this.isView(view) }
		},
		onFileUploading (value) {
			this.form.uploading = value
		}
	},
	created () {
		switch (this.params.action) {
			case 'add':
				this.model.data = this.newHealthReport()
				break
			case 'edit':
				this.getReport()
				break
			default:
				this.$log.warn(this.name, 'action not set')()
		}
	}
}
</script>



// WEBPACK FOOTER //
// src/components/watch/healthreports/HealthReportForm.vue